<div class="starred-panel" [class.open]="isOpen">
  <div class="starred-header">
    <div class="d-flex align-items-center w-100">
      <button class="btn btn-icon mr-1" (click)="onClose()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
      </button>
      <h6 class="mb-0">Starred</h6>
    </div>
  </div>

  <div class="starred-search p-3">
    <div class="search-container">
      <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      </svg>
      <input type="text" [(ngModel)]="searchQuery" (ngModelChange)="onSearchChange()" placeholder="Search"
        class="form-control">
    </div>
  </div>

  <div class="starred-body" (scroll)="onScroll($event)">
    @if (filteredMessages.length === 0 && !isLoading) {
    <div class="text-center mt-5 px-4">
      <div class="empty-star-icon mb-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ccc"
          stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
          <polygon
            points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
          </polygon>
        </svg>
      </div>
      <p class="text-muted">No starred messages found.</p>
    </div>
    }

    <div class="starred-list pb-3">
      @for (message of filteredMessages; track (message._id || message.id || i); let i = $index) {
      <div class="starred-message-item mb-1" (click)="onMessageClick(message)">
        <div class="d-flex w-100">
          <!-- Avatar -->
          <div class="avatar-col mr-3">
            <img
              [src]="profileImageMapping[message.message?.sender_id] || profileImageMapping[message.sender_id] || 'assets/user-icon.png'"
              class="rounded-circle" width="30" height="30" (error)="handleProfileImageError($event)">
          </div>

          <!-- Content Column -->
          <div class="content-col flex-grow-1 min-width-0">
            <!-- Header Row -->
            <div class="d-flex justify-content-between align-items-center mb-1">
              <div class="sender-info text-truncate mr-2">
                <span class="sender-name font-weight-bold">
                  {{ message.message?.sender_id === userId ? 'You' : (userNameMapping[message.message?.sender_id] ||
                  message.message?.name || 'User') }}
                </span>
                <span class="chat-separator mx-1 text-muted"> - </span>
                <span class="chat-target-name text-muted">{{ getChatName(message) }}</span>
              </div>
              <div class="time-col">
                <small class="text-muted white-space-nowrap">{{ message.createdAt | date:'h:mm a' }}</small>
                <i class="fa fa-angle-right ml-2 text-muted small"></i>
              </div>
            </div>

            <!-- Bubble Row -->
            <div class="bubble-row">
              <div class="message-bubble" [class.sender]="message.message?.sender_id === userId">
                <!-- Forwarded Indicator -->
                @if ((message.message || message).meta?.isForwarded) {
                <div class="forwarded-indicator d-flex justify-content-start align-items-center mb-1"
                  [class.sender]="userId === (message.message || message).sender_id">
                  <svg style="margin-right: 4px" xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                    viewBox="0 0 24 24">
                    <path fill="currentColor" d="m15 5l-1.41 1.41L18.17 11H2V13h16.17l-4.59 4.59L15 19l7-7z" />
                  </svg>
                  <p class="forwarded-text mb-0">Forwarded from {{ (message.message || message).meta?.forwardedFrom ||
                    'Unknown' }}</p>
                </div>
                }


                @if (getFilesFromMessage(message).length > 1) {
                <div class="files-carousel-container">

                  <div class="carousel-wrapper">
                    <div class="carousel-inner">
                      @for (file of getFilesFromMessage(message); track file.fileUrl; let j = $index) {
                      <div class="carousel-item" [class.active]="(message.currentSlideIndex || 0) === j">
                        @if (file.type?.startsWith('image/')) {
                        <div class="image-box">
                          <img [src]="file.fileUrl" (error)="handleMediaError($event, message)" class="starred-thumb" />
                        </div>
                        }
                        @if (file.type?.startsWith('video/')) {
                        <div class="video-box">
                          <video [src]="file.fileUrl" class="starred-thumb" poster="assets/video-file.jpg"></video>
                        </div>
                        }
                        @if (file.type?.startsWith('audio/') || isVoiceMessage(file.fileUrl)) {
                        <div class="starred-audio-player voice-message-ui p-2 rounded d-flex align-items-center"
                          [class.sender]="message.message?.sender_id === userId">
                          <div class="audio-main d-flex align-items-center w-100">
                            <!-- Avatar -->
                            <div class="voice-avatar-container mr-2">
                              <img
                                [src]="message.message?.sender_id === userId ? (profileImageMapping[userId] || 'assets/user-icon.png') : (profileImageMapping[message.sender_id] || 'assets/user-icon.png')"
                                class="voice-avatar-img">
                              <div class="voice-mic-icon">
                                <svg width="8" height="8" viewBox="0 0 24 24" fill="currentColor">
                                  <path
                                    d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
                                  <path
                                    d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
                                </svg>
                              </div>
                            </div>

                            <!-- Play Button -->
                            <button class="audio-play-btn mr-2" (click)="togglePlay($event, message)">
                              <i class="fa"
                                [class.fa-pause]="currentlyPlayingId === (message.messageId || message._id) && activeAudio && !activeAudio.paused"
                                [class.fa-play]="!(currentlyPlayingId === (message.messageId || message._id) && activeAudio && !activeAudio.paused)"></i>
                            </button>

                            <!-- Audio Info (Waveform + Time) -->
                            <div class="audio-info flex-grow-1 min-width-0">
                              <div class="voice-scrubber-wrapper position-relative" style="height: 24px;">
                                <!-- Unfilled -->
                                <div
                                  class="fake-waveform unfilled d-flex align-items-center w-100 h-100 position-absolute"
                                  style="gap: 2px;">
                                  <div class="wave-bar" style="height: 40%"></div>
                                  <div class="wave-bar" style="height: 80%"></div>
                                  <div class="wave-bar" style="height: 50%"></div>
                                  <div class="wave-bar" style="height: 100%"></div>
                                  <div class="wave-bar" style="height: 70%"></div>
                                  <div class="wave-bar" style="height: 30%"></div>
                                  <div class="wave-bar" style="height: 90%"></div>
                                  <div class="wave-bar" style="height: 60%"></div>
                                  <div class="wave-bar" style="height: 40%"></div>
                                  <div class="wave-bar" style="height: 80%"></div>
                                  <div class="wave-bar" style="height: 50%"></div>
                                  <div class="wave-bar" style="height: 100%"></div>
                                  <div class="wave-bar" style="height: 70%"></div>
                                  <div class="wave-bar" style="height: 30%"></div>
                                  <div class="wave-bar" style="height: 90%"></div>
                                  <div class="wave-bar" style="height: 60%"></div>
                                  <div class="wave-bar" style="height: 40%"></div>
                                  <div class="wave-bar" style="height: 80%"></div>
                                  <div class="wave-bar" style="height: 50%"></div>
                                  <div class="wave-bar" style="height: 100%"></div>
                                  <div class="wave-bar" style="height: 70%"></div>
                                  <div class="wave-bar" style="height: 30%"></div>
                                  <div class="wave-bar" style="height: 90%"></div>
                                  <div class="wave-bar" style="height: 60%"></div>
                                  <div class="wave-bar" style="height: 40%"></div>
                                  <div class="wave-bar" style="height: 80%"></div>
                                  <div class="wave-bar" style="height: 50%"></div>
                                  <div class="wave-bar" style="height: 100%"></div>
                                  <div class="wave-bar" style="height: 70%"></div>
                                  <div class="wave-bar" style="height: 30%"></div>
                                  <div class="wave-bar" style="height: 90%"></div>
                                  <div class="wave-bar" style="height: 60%"></div>
                                </div>
                                <!-- Filled -->
                                <div
                                  class="fake-waveform filled d-flex align-items-center w-100 h-100 position-absolute"
                                  [style.--percent]="audioProgress[message.messageId || message._id]?.currentTime / audioProgress[message.messageId || message._id]?.duration || 0"
                                  style="gap: 2px; z-index: 2;">
                                  <div class="wave-bar" style="height: 40%"></div>
                                  <div class="wave-bar" style="height: 80%"></div>
                                  <div class="wave-bar" style="height: 50%"></div>
                                  <div class="wave-bar" style="height: 100%"></div>
                                  <div class="wave-bar" style="height: 70%"></div>
                                  <div class="wave-bar" style="height: 30%"></div>
                                  <div class="wave-bar" style="height: 90%"></div>
                                  <div class="wave-bar" style="height: 60%"></div>
                                  <div class="wave-bar" style="height: 40%"></div>
                                  <div class="wave-bar" style="height: 80%"></div>
                                  <div class="wave-bar" style="height: 50%"></div>
                                  <div class="wave-bar" style="height: 100%"></div>
                                  <div class="wave-bar" style="height: 70%"></div>
                                  <div class="wave-bar" style="height: 30%"></div>
                                  <div class="wave-bar" style="height: 90%"></div>
                                  <div class="wave-bar" style="height: 60%"></div>
                                  <div class="wave-bar" style="height: 40%"></div>
                                  <div class="wave-bar" style="height: 80%"></div>
                                  <div class="wave-bar" style="height: 50%"></div>
                                  <div class="wave-bar" style="height: 100%"></div>
                                  <div class="wave-bar" style="height: 70%"></div>
                                  <div class="wave-bar" style="height: 30%"></div>
                                  <div class="wave-bar" style="height: 90%"></div>
                                  <div class="wave-bar" style="height: 60%"></div>
                                  <div class="wave-bar" style="height: 40%"></div>
                                  <div class="wave-bar" style="height: 80%"></div>
                                  <div class="wave-bar" style="height: 50%"></div>
                                  <div class="wave-bar" style="height: 100%"></div>
                                  <div class="wave-bar" style="height: 70%"></div>
                                  <div class="wave-bar" style="height: 30%"></div>
                                  <div class="wave-bar" style="height: 90%"></div>
                                  <div class="wave-bar" style="height: 60%"></div>
                                  <div class="waveform-thumb"
                                    [style.left]="'calc(' + ((audioProgress[message.messageId || message._id]?.currentTime / audioProgress[message.messageId || message._id]?.duration || 0) * 100) + '% - 4px)'">
                                  </div>
                                </div>
                              </div>
                              <div class="voice-meta-row mt-1">
                                <span class="voice-duration text-muted" style="font-size: 11px;">
                                  {{ currentlyPlayingId === (message.messageId || message._id) ?
                                  formatDuration(audioProgress[message.messageId || message._id]?.currentTime || 0) :
                                  ((message.message || message).meta?.duration ? formatDuration((message.message || message).meta.duration) : '0:00') }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        }
                        @if (!file.type?.startsWith('image/') && !file.type?.startsWith('video/') &&
                        !file.type?.startsWith('audio/')) {
                        <div
                          class="starred-document-box-new d-flex align-items-center justify-content-between p-2 rounded">
                          <span class="starred-file-name-new text-truncate mr-2">{{ file.name }}</span>
                          <div class="starred-download-circle">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                              viewBox="0 0 16 16">
                              <path
                                d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                              <path
                                d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                            </svg>
                          </div>
                        </div>
                        }
                      </div>
                      }
                    </div>

                    <div class="carousel-controls">
                      <button class="carousel-control prev" (click)="prevSlide(message); $event.stopPropagation()">
                        <i class="fa fa-angle-left"></i>
                      </button>
                      <div class="carousel-indicators">
                        <span>{{ (message.currentSlideIndex || 0) + 1 }} / {{ getFilesFromMessage(message).length
                          }}</span>
                      </div>
                      <button class="carousel-control next" (click)="nextSlide(message); $event.stopPropagation()">
                        <i class="fa fa-angle-right"></i>
                      </button>
                    </div>
                  </div>
                </div>
                } @else if ((getReplyThumbnail(message) || getFilesFromMessage(message).length === 1) &&
                !hasLinkMeta(message)) {
                <div class="starred-media-preview mt-2" [class.no-margin]="!(message.message?.message || message.msg)">
                  @if (getReplyMediaType(message) === 'Photo' || getReplyMediaType(message) === 'GIF') {
                  <img [src]="getReplyThumbnail(message)" (error)="handleMediaError($event, message)"
                    class="starred-thumb" />
                  } @else if (getReplyMediaType(message) === 'Video') {
                  <div class="video-preview">
                    <video [src]="(message.message?.url || message.url || getFilesFromMessage(message)[0]?.fileUrl)"
                      [poster]="getReplyThumbnail(message)" controls muted playsinline preload="auto"
                      class="starred-thumb">
                    </video>
                  </div>
                  } @else if (getReplyMediaType(message) === 'Audio' || getReplyMediaType(message) === 'Voice Message')
                  {
                  <div class="starred-audio-player voice-message-ui p-2 rounded d-flex align-items-center"
                    [class.sender]="message.message?.sender_id === userId">
                    <div class="audio-main d-flex align-items-center w-100">
                      <!-- Avatar -->
                      <div class="voice-avatar-container mr-2">
                        <img
                          [src]="message.message?.sender_id === userId ? (profileImageMapping[userId] || 'assets/user-icon.png') : (profileImageMapping[message.sender_id] || 'assets/user-icon.png')"
                          class="voice-avatar-img">
                        <div class="voice-mic-icon">
                          <svg width="8" height="8" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
                            <path
                              d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
                          </svg>
                        </div>
                      </div>

                      <!-- Play Button -->
                      <button class="audio-play-btn mr-2" (click)="togglePlay($event, message)">
                        <i class="fa"
                          [class.fa-pause]="currentlyPlayingId === (message.messageId || message._id) && activeAudio && !activeAudio.paused"
                          [class.fa-play]="!(currentlyPlayingId === (message.messageId || message._id) && activeAudio && !activeAudio.paused)"></i>
                      </button>

                      <!-- Audio Info (Waveform + Time) -->
                      <div class="audio-info flex-grow-1 min-width-0">
                        <div class="voice-scrubber-wrapper position-relative" style="height: 24px;">
                          <!-- Unfilled -->
                          <div class="fake-waveform unfilled d-flex align-items-center w-100 h-100 position-absolute"
                            style="gap: 2px;">
                            <div class="wave-bar" style="height: 40%"></div>
                            <div class="wave-bar" style="height: 80%"></div>
                            <div class="wave-bar" style="height: 50%"></div>
                            <div class="wave-bar" style="height: 100%"></div>
                            <div class="wave-bar" style="height: 70%"></div>
                            <div class="wave-bar" style="height: 30%"></div>
                            <div class="wave-bar" style="height: 90%"></div>
                            <div class="wave-bar" style="height: 60%"></div>
                            <div class="wave-bar" style="height: 40%"></div>
                            <div class="wave-bar" style="height: 80%"></div>
                            <div class="wave-bar" style="height: 50%"></div>
                            <div class="wave-bar" style="height: 100%"></div>
                            <div class="wave-bar" style="height: 70%"></div>
                            <div class="wave-bar" style="height: 30%"></div>
                            <div class="wave-bar" style="height: 90%"></div>
                            <div class="wave-bar" style="height: 60%"></div>
                            <div class="wave-bar" style="height: 40%"></div>
                            <div class="wave-bar" style="height: 80%"></div>
                            <div class="wave-bar" style="height: 50%"></div>
                            <div class="wave-bar" style="height: 100%"></div>
                            <div class="wave-bar" style="height: 70%"></div>
                            <div class="wave-bar" style="height: 30%"></div>
                            <div class="wave-bar" style="height: 90%"></div>
                            <div class="wave-bar" style="height: 60%"></div>
                            <div class="wave-bar" style="height: 40%"></div>
                            <div class="wave-bar" style="height: 80%"></div>
                            <div class="wave-bar" style="height: 50%"></div>
                            <div class="wave-bar" style="height: 100%"></div>
                            <div class="wave-bar" style="height: 70%"></div>
                            <div class="wave-bar" style="height: 30%"></div>
                            <div class="wave-bar" style="height: 90%"></div>
                            <div class="wave-bar" style="height: 60%"></div>
                          </div>
                          <!-- Filled -->
                          <div class="fake-waveform filled d-flex align-items-center w-100 h-100 position-absolute"
                            [style.--percent]="audioProgress[message.messageId || message._id]?.currentTime / audioProgress[message.messageId || message._id]?.duration || 0"
                            style="gap: 2px; z-index: 2;">
                            <div class="wave-bar" style="height: 40%"></div>
                            <div class="wave-bar" style="height: 80%"></div>
                            <div class="wave-bar" style="height: 50%"></div>
                            <div class="wave-bar" style="height: 100%"></div>
                            <div class="wave-bar" style="height: 70%"></div>
                            <div class="wave-bar" style="height: 30%"></div>
                            <div class="wave-bar" style="height: 90%"></div>
                            <div class="wave-bar" style="height: 60%"></div>
                            <div class="wave-bar" style="height: 40%"></div>
                            <div class="wave-bar" style="height: 80%"></div>
                            <div class="wave-bar" style="height: 50%"></div>
                            <div class="wave-bar" style="height: 100%"></div>
                            <div class="wave-bar" style="height: 70%"></div>
                            <div class="wave-bar" style="height: 30%"></div>
                            <div class="wave-bar" style="height: 90%"></div>
                            <div class="wave-bar" style="height: 60%"></div>
                            <div class="wave-bar" style="height: 40%"></div>
                            <div class="wave-bar" style="height: 80%"></div>
                            <div class="wave-bar" style="height: 50%"></div>
                            <div class="wave-bar" style="height: 100%"></div>
                            <div class="wave-bar" style="height: 70%"></div>
                            <div class="wave-bar" style="height: 30%"></div>
                            <div class="wave-bar" style="height: 90%"></div>
                            <div class="wave-bar" style="height: 60%"></div>
                            <div class="wave-bar" style="height: 40%"></div>
                            <div class="wave-bar" style="height: 80%"></div>
                            <div class="wave-bar" style="height: 50%"></div>
                            <div class="wave-bar" style="height: 100%"></div>
                            <div class="wave-bar" style="height: 70%"></div>
                            <div class="wave-bar" style="height: 30%"></div>
                            <div class="wave-bar" style="height: 90%"></div>
                            <div class="wave-bar" style="height: 60%"></div>
                          </div>
                        </div>
                        <div class="voice-meta-row mt-1">
                          <span class="voice-duration text-muted" style="font-size: 11px;">
                            {{ currentlyPlayingId === (message.messageId || message._id) ?
                            formatDuration(audioProgress[message.messageId || message._id]?.currentTime || 0) :
                            ((message.message || message).meta?.duration ? formatDuration((message.message || message).meta.duration) : '0:00') }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  } @else {
                  <div
                    class="starred-document-box-new d-flex align-items-center justify-content-between p-2 rounded mb-1">
                    <span class="starred-file-name-new text-truncate mr-2">{{ getFilesFromMessage(message)[0]?.name ||
                      'Document' }}</span>
                    <div class="starred-download-circle">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        viewBox="0 0 16 16">
                        <path
                          d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                        <path
                          d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                      </svg>
                    </div>
                  </div>
                  }
                </div>
                }



                <!-- Text Caption (Moved to Bottom) -->
                @if ((message.message?.message || message.msg) && !isMessageRedundantWithFile(message.message ||
                message)) {
                <div [class.mt-2]="getFilesFromMessage(message).length > 0 || getReplyThumbnail(message)">
                  @if (isURL(message.message?.message || message.msg)) {
                  <div class="url-preview-container"
                    (click)="openUrl(message.message?.message || message.msg); $event.stopPropagation()">
                    <a [href]="message.message?.message || message.msg" target="_blank" rel="noopener noreferrer"
                      class="mb-0 text-break starred-link link-url">
                      {{ message.message?.message || message.msg }}
                    </a>

                    @if (hasLinkMeta(message)) {
                    <div class="telegram-preview-content" [class.icon-mode]="isIconMode(message)">
                      <div class="preview-text-content">
                        @if (getMessageMeta(message.message || message).title) {
                        <p class="meta-title">{{ getMessageMeta(message.message || message).title }}</p>
                        }
                        @if (getMessageMeta(message.message || message).description) {
                        <p class="meta-description">{{ getMessageMeta(message.message || message).description }}</p>
                        }
                      </div>

                      @if (isIconMode(message)) {
                      <div class="icon-image-container">
                        <img [src]="getMessageMeta(message.message || message).icon"
                          (error)="onPreviewIconError(message)" class="icon-thumbnail" />
                      </div>
                      }

                      @if (getMessageMeta(message.message || message).image &&
                      isValidImageUrl(getMessageMeta(message.message || message).image) &&
                      !getMessageMeta(message.message || message).imageBroken && !isIconMode(message)) {
                      <div class="preview-image-container">
                        <img [src]="getMessageMeta(message.message || message).image"
                          (error)="onPreviewImageError(message)" class="telegram-thumbnail" />
                      </div>
                      }
                    </div>
                    }
                  </div>
                  } @else {
                  <p class="mb-0 text-break"
                    [innerHTML]="getDisplayMessage((message.message?.message || message.msg || message.message?.meta?.caption), (message.messageId || message._id || message.id))">
                  </p>
                  @if (isMessageLong(message.message?.message || message.msg || message.message?.meta?.caption)) {
                  <span class="read-more-link"
                    (click)="toggleMessageExpand(message.messageId || message._id || message.id); $event.stopPropagation()">
                    {{ isMessageExpanded(message.messageId || message._id || message.id) ? ' Show less' : ' Read more'
                    }}
                  </span>
                  }
                  }
                </div>
                }

                <!-- Footer in bubble -->
                <div class="bubble-footer d-flex align-items-center justify-content-end mt-1">
                  <svg class="starred-tiny-icon mr-1" viewBox="0 0 24 24" width="12" height="12">
                    <path fill="currentColor"
                      d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z">
                    </path>
                  </svg>
                  <small class="text-muted tiny-time">{{ message.createdAt | date:'h:mm a' }}</small>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      }
    </div>

    @if (isLoading) {
    <div class="text-center p-3">
      <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
    </div>
    }
  </div>
</div>

<div class="starred-backdrop" [class.show]="isOpen" (click)="onClose()"></div>